import { DiscountLine } from "./Lines/DiscountLine";
import { NextPaymentLine } from "./Lines/NextPaymentLine";
import { TotalDueLine } from "./Lines/TotalDueLine";
import { ViewOrderDetailsLine } from "./Lines/ViewOrderDetailsLine";

export const CheckoutPagePreview = () => (
  <>
    <div className="flex flex-col gap-y-0.5">
      <div className="flex flex-row justify-between">
        <TotalDueLine />
      </div>
      <div className="flex flex-row justify-between">
        <ViewOrderDetailsLine />
        <DiscountLine />
      </div>
    </div>
    <NextPaymentLine />
  </>
);
